// extracted by mini-css-extract-plugin
module.exports = {"title":"AlbumRow-title-28FeW TableRowCell-cell-2fbg4","monitored":"AlbumRow-monitored-35SCX TableRowCell-cell-2fbg4","status":"AlbumRow-status-3sDgq TableRowCell-cell-2fbg4"};